import { render, staticRenderFns } from "./StartingOrderTableComponent.vue?vue&type=template&id=3b9aa264&scoped=true"
import script from "./StartingOrderTableComponent.vue?vue&type=script&lang=js"
export * from "./StartingOrderTableComponent.vue?vue&type=script&lang=js"
import style0 from "./StartingOrderTableComponent.vue?vue&type=style&index=0&id=3b9aa264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9aa264",
  null
  
)

export default component.exports